import { type ContentObjectList, createContentObjectList } from 'models';
import { useInfiniteQuery } from 'query';
import type { ApiClientResponseError, DefaultResponseErrorDataObject } from 'common/services';
import { getBookmarksFeed } from '../services';
import { getBookmarksFeedInfiniteQueryKey } from './keys';

type P = {
  limit: number;
};

export const useBookmarksFeedInfiniteQuery = ({ limit }: P) =>
  useInfiniteQuery<ContentObjectList[], string | undefined, ApiClientResponseError<DefaultResponseErrorDataObject>>({
    async queryFn({ pageParam: cursor }) {
      const { data } = await getBookmarksFeed({
        config: {
          params: {
            cursor,
            limit,
          },
        },
      });

      return data.map((contentObject) => createContentObjectList(contentObject));
    },
    getNextPageParam: (lastPage) => (lastPage.length < limit ? undefined : lastPage.at(-1)?.id),
    initialPageParam: undefined,
    queryKey: getBookmarksFeedInfiniteQueryKey({}),
    gcTime: 0,
  });
